import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useSidebars } from '@/hooks/use-sidebars';
import { Icon } from '@/ui/icons/icon';
import { Tooltip } from '@/ui/tooltip/tooltip';

import { NavButton } from '../navbar.styles';

import { CreateDropdown } from '../../../components/create-dropdown/create-dropdown';
import { styled } from 'goober';

export function TooltipDropdownCreate() {
  const { isNavbarOpen } = useSidebars();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { t } = useTranslation('default');

  return (
    <CreateDropdown
      triggerButton={
        <Tooltip
          visible={!isNavbarOpen && !isDropdownOpen}
          content={t`Create`}
          placement="right"
        >
          <NavButton selected={isDropdownOpen}>
            <StyledIcon icon="Create" />
            {isNavbarOpen && <span>{t`Create`}</span>}
          </NavButton>
        </Tooltip>
      }
      setIsDropdownOpen={setIsDropdownOpen}
    />
  );
}

const StyledIcon = styled(Icon)`
  margin: auto;
  .is-open & {
    margin: 0;
  }
`;
